/** @jsx jsx */
import { Route, RouteProps, Redirect } from 'react-router-dom';
import { css, jsx } from '@emotion/core';
import RevisionDomain from 'domain/revision';
import _ from 'lodash';
import React, { useState, useEffect, useCallback } from 'react';
import LoginUserDomain from 'domain/loginUser';
import moment from 'moment';
import { getRevision } from './api/revision';
import { getUserInfo, getLoginUser, getLoginUserPeople } from 'api/singleLogin';
import useToastNotification from 'hooks/useToastNotification';
import { isMobileOnly } from "react-device-detect";
import { useHistory, useLocation } from "react-router-dom";
import { getPeopleUserInfo, getOAuthCode, getOAuthCodeV2 } from 'hooks/usePKCEOAuth';
import SalesMenuTypeDomain from 'domain/master/sales/salesMenuType';
import { Auth } from 'aws-amplify';
import getItem, { getUserLoginStatus, saveAccessHistory, saveLoginHistory } from 'api/login';
import { getBreakId } from 'api/getBreakId';
import clearLocalStorageAfterLogout from 'hooks/useClearLocalStorageAfterLogout';
import { useDispatch } from 'react-redux';
import { uiAppBarActions } from 'modules/ui/appBar';
import Modal from "components/molecules/Modal";
import { Link } from 'react-router-dom';
import productColor, { grayScale } from 'components/styles';
import Icon from 'components/atoms/Icon';
// import Sidebar from 'components/templates/Sidebar';
import useLoginUser from 'hooks/useLoginUser';
import Appbar from 'components/organismos/Appbar';
import FlexBox from "components/atoms/FlexBox";
import SidebarLeft from 'components/templates/SidebarLeft';
import { administratorRole, hrRole, leadRole, staffRole, subLeadRole } from 'utility/permissionRole';
import { recorderActions } from 'modules/ui/timeRecorder';
const isPhone = window.matchMedia("(max-width: 480px)").matches;

declare let gRevision: string;
const REVISION_KEY: string = 'EC_APP_REVISION';

/**
  * リビジョン管理用 ローカルストレージ保存
  *
  * @param obj セッション格納オブジェクト
*/
function setLocalStorageRevision(obj: any) {
  localStorage.setItem(
    REVISION_KEY, 
    JSON.stringify({ ...JSON.parse(localStorage.getItem(REVISION_KEY) || '{}'), ...obj })
  );
}

/**
 * リビジョン管理用 ローカルストレージ取得
 *
 * @param key
 * @returns key セッションキー
*/
function getLocalStorageRevision(key: string) {
  if (!JSON.parse(localStorage.getItem(REVISION_KEY) || '{}') || !JSON.parse(localStorage.getItem(REVISION_KEY) || '{}')[key]) {
    return false;
  }

  return JSON.parse(localStorage.getItem(REVISION_KEY) || '{}')[key];
}

/**
 * ログイン中のユーザ情報を取得
*/
// async function getUserInfo() {
//   const userInfo = await Auth.currentAuthenticatedUser();
//   console.log(`userInfo = ${userInfo}`);
//   return userInfo;
// }

const checkPermissionUser = (
  history: any,
  location: any,
  rolePermission: string,
  isAdministrator: boolean,
  isHavingApprovalPrivilege: boolean,
  showFaceStamp: boolean,
  showGpsStamp: boolean,
  showIdStamp: boolean
) => {
  const pathCurrent = location;

  let isAccess = true;

  // システム管理者
  if (pathCurrent) {
    if (parseInt(rolePermission) === 3 && isAdministrator) {
      if (administratorRole.indexOf(String(pathCurrent)) === -1) {
        isAccess = false;
      }
    }
    // 人事管理
    else if (parseInt(rolePermission) === 3 && !isAdministrator) {
      if (hrRole.indexOf(String(pathCurrent)) === -1) {
        isAccess = false;
      }
    }
    // 組織管理者
    else if (parseInt(rolePermission) === 2 && isAdministrator) {
      if (leadRole.indexOf(String(pathCurrent)) === -1) {
        isAccess = false;
      }
    }
    // 組織副管理者
    else if (parseInt(rolePermission) === 2 && !isAdministrator) {
      if (subLeadRole.indexOf(String(pathCurrent)) === -1) {
        isAccess = false;
      }
    }
    // 従業員
    else {
      if (staffRole.indexOf(String(pathCurrent)) === -1) {
        isAccess = false;
      }

      if (pathCurrent == 'recorder' && (!showFaceStamp && !showGpsStamp && !showIdStamp)) {
        isAccess = false;
      }
    }

    if (['attendApplicationApproval'].indexOf(String(pathCurrent)) !== -1 && isHavingApprovalPrivilege === true) {
      isAccess = true;
    }
  }

  if (!isAccess) {
    history.push('/404');
  }
};

const PrivateRoute: React.FC<RouteProps> = (props) => {
  // redux
  const dispatch = useDispatch();
  const { staffName } = useLoginUser();

  const rest = _.omit(props, ['component']);

  // let moveApproval: boolean = false;
  // const location = useLocation();
  const { errorNotification } = useToastNotification();
  const [loginUser, setLoginUser] = useState<LoginUserDomain | any>(null);
  const history = useHistory();
  const redirectPeopleLogin = process.env.REACT_APP_PEOPLE_URL || "";
  const isAuthorizedFromPeople = process.env.REACT_APP_IS_AUTHORIZED_FROM_PEOPLE || false;
  const [isAlert, setIsAlert] = useState(false);

  let loginPath: string = '/login';
  let moveApproval: boolean = false;
  const location = useLocation();
  const previous = sessionStorage.getItem('path') || '';

  useEffect(() => {
    let isAlerted = sessionStorage.getItem('loginUser.isAlerted') === 'true';
    
    if (!isAlerted && sessionStorage.getItem('loginUser.isAlertClosingDate') === 'true') {
      sessionStorage.setItem('loginUser.isAlerted', 'true');
      setIsAlert(true);
    }
  });

  useEffect(() => {
    let localAccessToken = localStorage.getItem('ACCESS_TOKEN');

    if (isAuthorizedFromPeople === "true" && localAccessToken !== null && localAccessToken !== undefined) {
      getUserLoginStatus().then((res) => {
        let logStatus = res;
        localStorage.setItem('loginUser.isLogged', logStatus);

        if (logStatus === 'false' || logStatus == false) {
          history.replace('/logout');
        }
      }).catch((err: any) => {
        // console.log("checkLoginError", err.response);
        errorNotification(err.response.data.defaultMessage);
      });
    }
  }, [location]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location]);

  useEffect(() => {
    if (location.pathname.split('/')[1] !== (previous ? previous.split('/')[1] : '')) {
      for (const key in sessionStorage) {
        if (sessionStorage.hasOwnProperty(key)) {
          if (key.search(`sessionData${previous}`) !== -1 && 'loginUser'.indexOf(key) === -1) {
            sessionStorage.removeItem(key);
          }
        }
      }
    }

    sessionStorage.setItem('path', location.pathname);
    
    window.addEventListener("beforeunload", () => {
      for (const key in sessionStorage) {
        if (sessionStorage.hasOwnProperty(key)) {
          if (key.search(`sessionData${previous}`) !== -1 && 'loginUser'.indexOf(key) === -1) {
            sessionStorage.removeItem(key);
          }
        }
      }
    })
  }, [previous, location]);

  // Save values on screen during operation and assign default values when returning to the screen
  if (
    [
      '/agreementMaster', 
      '/holidayMaster/create', 
      '/holidayMaster/import', 
      '/holidayMaster/edit/:publicHolidayId', 
      '/holiday'
    ].indexOf(String(rest.path)) !== -1
  ) {
    if (!sessionStorage.getItem('selectedOrgCodeHolidayMaster')) {
      sessionStorage.setItem('selectedOrgCodeHolidayMaster', 'all');
    }
    if (!sessionStorage.getItem('selectedYearHolidayMaster')) {
      sessionStorage.setItem('selectedYearHolidayMaster', new Date().getFullYear().toString());
    }
  } else {
    sessionStorage.removeItem('selectedOrgCodeHolidayMaster');
    sessionStorage.removeItem('selectedYearHolidayMaster');
  }

  if (
    [
      '/masterShiftPattern', 
      '/masterShiftPattern/add', 
      '/masterShiftPattern/:typeButton/:shiftPatternId'
    ].indexOf(String(rest.path)) === -1
  ) {
    sessionStorage.removeItem('shiftPatternOrgCode');
  }

  if (
    [
      '/organizations', 
      '/organizations/add', 
      '/organizations/csv', 
      '/organizations/:orgCode/specialsalary', 
      '/organizations/:orgCode/managers', 
      '/organizations/:orgCode'
    ].indexOf(String(rest.path)) === -1
  ) {
    sessionStorage.removeItem('organizations.noManager');
    sessionStorage.removeItem('organizations.unsetTargetDate');
    sessionStorage.removeItem('organizations.orgStatus');
  }

  if (
    [
      '/masterEmploymentForm', 
      '/masterEmploymentForm/add', 
      '/masterEmploymentForm/edit/:isEdit/:employmentId/:applyStartDate'
    ].indexOf(String(rest.path)) === -1
  ) {
    sessionStorage.removeItem('masterEmploymentForm.applyDate');
    sessionStorage.removeItem('masterEmploymentForm.applyDate');
  }

  if (
    [
      '/attendResult', 
      '/attendStampList', 
      '/attendStampModificationApplication', 
      '/attendStampModificationApplication', 
      '/attendHolidayApplication', 
      '/attendOvertimeApplication', 
      '/attendHolidayworkApplication', 
      '/attendTransferApplication'
    ].indexOf(String(rest.path)) === -1
  ) {
    sessionStorage.removeItem('attendResult.selectOrgCode');
    sessionStorage.removeItem('attendResult.searchTargetDateFrom');
    sessionStorage.removeItem('attendResult.searchTargetDateTo');
  }

  if (
    ['/approvalModificationApplication/:applicationId'].indexOf(String(rest.path)) !== -1 || 
    ['/approvalHolidayApplication/:applicationId'].indexOf(String(rest.path)) !== -1 || 
    ['/approvalOvertimeApplication/:applicationId'].indexOf(String(rest.path)) !== -1 || 
    ['/approvalHolidayworkApplication/:applicationId'].indexOf(String(rest.path)) !== -1 || 
    ['/approvalTransferApplication/:applicationId'].indexOf(String(rest.path)) !== -1
  ) {
    moveApproval = true;
    loginPath = `/login${location.pathname}`;
  }

  saveAccessHistory(
    sessionStorage.getItem('loginUser.companyCode') || '', 
    sessionStorage.getItem('loginUser.staffCode') || '', 
    location.pathname
  );

  // リビジョンチェック
  getRevision().then((response: any) => {
    const revision = new RevisionDomain(response);

    // 現在のリビジョンと取得したリビジョンが異なる場合、リロード
    if (gRevision !== revision.revision) {
      // 無限リロード対策（更新中フラグで管理する）
      const revisionChangingFl = getLocalStorageRevision('revision_changing_fl');

      setLocalStorageRevision({ revision_changing_fl: true });

      if (!revisionChangingFl) {
        // リビジョン更新
        window.location.reload(true);
      }
    } else {
      // リビジョンが一致
      // LocalStorageのリビジョン更新フラグをfalse
      setLocalStorageRevision({ revision_changing_fl: false });
    }
  });

  // SessionStorageに[loginUser.mail]が存在しない場合
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // const [userInfo, setUserInfo] = useState(null);
  const [accessToken] = useState(localStorage.getItem('ACCESS_TOKEN'));
  const [peopleAccessToken] = useState(localStorage.getItem('PEOPLE_ACCESS_TOKEN'));
  const [tenant] = useState(localStorage.getItem('PEOPLE_TENANT'));


  // const [validPeopleToken, isValidPeopleToken] = useState(false);

  useEffect(() => {
    let referer = document.referrer;

    // console.log("tenant:", tenant);

    let checkExpiredToken = sessionStorage.getItem("isExpired") || "false";
    
    if (isAuthorizedFromPeople === 'true') {
      if (peopleAccessToken && accessToken) {
        getPeopleUserInfo(peopleAccessToken).then((response: any) => {
          if (response.status !== 200 || response.data['email'] === null || response.data['email'] === "null") {
            errorNotification("Invalid Email.");
            setIsAuthenticated(true);
            history.replace('/logout');
          }

          getLoginUser(response.data['email'], accessToken).then((res: any) => {
            if (res.status !== 200) {
              history.replace('/logout');
            } else {
              setLoginUser(new LoginUserDomain(res.data));
            }
            setIsAuthenticated(true);
          }).catch((res) => {
            // console.log(res);
            setIsAuthenticated(true);
            history.replace('/logout');
          });
        }).catch((res) => {
          // console.log(res);
          setIsAuthenticated(true);
          history.replace('/logout');
        });
      } else if (checkExpiredToken == "true") {
        clearLocalStorageAfterLogout();
        sessionStorage.clear();
        history.replace('/expired');
        return;
      } else if (tenant === "" || tenant === null) {
        history.replace('/error');
        return;
      } else {
        let tenant = localStorage.getItem("PEOPLE_TENANT") || "";
        clearLocalStorageAfterLogout();
        sessionStorage.clear();
        let callback = window.location.origin + "/callback";
        // let getOAuthStr= getOAuthCodeV2(callback);
        let getOAuthStr = getOAuthCode(callback, tenant);
        // let getOAuthStr= "/error";
        window.location.href = getOAuthStr;
        return;
      }
    } else {
      Auth.currentAuthenticatedUser().then((user: any) => {
        if (user) {
          const { attributes } = user;
          
          getItem(attributes.email, 'HQ').then((response: any) => {
            checkPermissionUser(
              history,
              location.pathname.split('/')[1],
              response.site,
              response.administrator,
              response.isHavingApprovalPrivilege,
              response.useBarcodeStamp,
              response.useFaceStamp,
              response.useGpsStamp
            );
            setLoginUser(new LoginUserDomain(response));
          }).catch((error: any) => {
            setIsAuthenticated(true);
          })
        } else {
          setIsAuthenticated(true);
        }
      }).catch((error: any) => {
        setIsAuthenticated(true);
      });
    }
  }, [isAuthenticated]);

  const [hasLoginUser, setGetLoginUser] = useState(false);
  
  useEffect(() => {
    if (loginUser) {
      if (isAuthorizedFromPeople === 'true') {
        localStorage.setItem("loginUser.isLogged", loginUser.isLogged);
      }

      // sessionStorage.setItem("loginUser.isLogged", loginUser.isLogged);
      sessionStorage.setItem("loginUser.mail", loginUser.mail);
      sessionStorage.setItem("loginUser.companyCode", loginUser.companyCode);
      sessionStorage.setItem("loginUser.staffCode", loginUser.staffCode);
      sessionStorage.setItem("loginUser.staffName", loginUser.staffName);
      sessionStorage.setItem("loginUser.isHavingApprovalPrivilege", String(loginUser.isHavingApprovalPrivilege));
      sessionStorage.setItem("loginUser.executiveId", loginUser.executiveId);
      sessionStorage.setItem("loginUser.orgCode", loginUser.orgCode);
      sessionStorage.setItem("loginUser.orgName", loginUser.orgName);
      sessionStorage.setItem("loginUser.personalRole", loginUser.personalRole);
      sessionStorage.setItem("loginUser.administrator", String(loginUser.administrator));
      sessionStorage.setItem("loginUser.site", String(loginUser.site));
      sessionStorage.setItem("loginUser.useGpsStamp", String(loginUser.useGpsStamp));
      sessionStorage.setItem("loginUser.useFaceStamp", String(loginUser.useFaceStamp));
      sessionStorage.setItem("loginUser.useBarcodeStamp", String(loginUser.useBarcodeStamp));
      sessionStorage.setItem("loginUser.barcodeId", String(loginUser.barcodeId));
      sessionStorage.setItem("loginUser.useInsideLoginFaceRecorderStamp", String(loginUser.useInsideLoginFaceRecorderStamp));
      sessionStorage.setItem("loginUser.useInsideLoginBarcodeStamp", String(loginUser.useInsideLoginBarcodeStamp));
      sessionStorage.setItem("loginUser.allOrganizationAccess", String(loginUser.allOrganizationAccess));
      sessionStorage.setItem('loginUser.workSystem', String(loginUser.workSystem));
      sessionStorage.setItem('loginUser.barcodeId', String(loginUser.barcodeId));
      sessionStorage.setItem('loginUser.isAlertClosingDate', String(loginUser.isAlertClosingDate));
      sessionStorage.setItem('loginUser.alertErrorStartDate', String(loginUser.alertErrorStartDate));
      sessionStorage.setItem('loginUser.alertErrorEndDate', String(loginUser.alertErrorEndDate));
      sessionStorage.setItem('loginUser.employmentCode', String(loginUser.employmentCode));
      const recorder = {
        useGpsStamp : loginUser?.useGpsStamp,
        useInsideLoginFaceRecorderStamp: loginUser?.useInsideLoginFaceRecorderStamp,
        useInsideLoginBarcodeStamp: loginUser?.useInsideLoginBarcodeStamp
      }
      dispatch(recorderActions.setRecorder(recorder));  
      const domainUrl = process.env.REACT_APP_PHOTO_BASE_URL;

      const photoPath = `${domainUrl}/${sessionStorage.getItem(
        "loginUser.companyCode"
      )}/${sessionStorage.getItem(
        "loginUser.staffCode"
      )}/1.jpg?${moment().valueOf()}`;

      if (!sessionStorage.getItem("loginUser.photoPath")) {
        sessionStorage.setItem("loginUser.photoPath", photoPath);
      }
      
      dispatch(uiAppBarActions.set_login_user(loginUser));
      dispatch(uiAppBarActions.changeAvatar(photoPath));

      if (loginUser.retired) {
        errorNotification("退職済みのためログインできません");
        saveLoginHistory(loginUser.mail, false, '', '退職済みのためログインできません');
      } else {
        setGetLoginUser(true);
      }

      // if (isMobileOnly) {
      //   setGetLoginUser(true);
      //   history.push("/attendStampList");
      // } else if (loginUser.site === 1) {
      //   setGetLoginUser(true);
      //   history.push("/attendStampList");
      // } else if (loginUser.site === 2) {
      //   setGetLoginUser(true);
      //   history.push("/dailyShift");
      // } else {
      //   setGetLoginUser(true);
      //   history.push("/attendApplicationApproval");
      // }

      setIsAuthenticated(true);

      getBreakId().then((response) => {
        if (response) {
          sessionStorage.setItem('loginUser.breakId', response.businessId || "");
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginUser]);

  // const user = getUserInfo();

  // useEffect(() => {
  //   Auth.currentAuthenticatedUser()
  //     .then((user: any) => {
  //       if (user) {
  //         const { attributes } = user;
  //         // const loginUserAuto = sessionStorage.getItem('loginUser');
  //         getItem(attributes.email, 'HQ')
  //           .then((response : any) => {
  //             const loginUser = new LoginUserDomain(response);
  //             // Save staff permission to session
  //             sessionStorage.setItem('loginUser.mail', loginUser.mail);
  //             sessionStorage.setItem('loginUser.companyCode', loginUser.companyCode);
  //             sessionStorage.setItem('loginUser.staffCode', loginUser.staffCode);
  //             sessionStorage.setItem('loginUser.staffName', loginUser.staffName);
  //             sessionStorage.setItem('loginUser.orgCode', loginUser.orgCode);
  //             sessionStorage.setItem('loginUser.personalRole', loginUser.personalRole);
  //             sessionStorage.setItem('loginUser.administrator', String(loginUser.administrator));
  //             sessionStorage.setItem('loginUser.site', String(loginUser.site));
  //             sessionStorage.setItem('loginUser.useGpsStamp', String(loginUser.useGpsStamp));
  //             const domainUrl = process.env.REACT_APP_PHOTO_BASE_URL;
  //             const photoPath = `${domainUrl
  //             }/${sessionStorage.getItem('loginUser.companyCode')
  //             }/${sessionStorage.getItem('loginUser.staffCode')
  //             }/1.jpg?${moment().valueOf()}`;
  //             sessionStorage.setItem('loginUser.photoPath', photoPath);
  //             if (loginUser.retired) {
  //               console.error('退職済みのためログインできません');
  //             } else {
  //               setGetLoginUser(true);
  //             }
  //             // setUserInfo(user);
  //             setIsAuthenticated(true);
  //           })
  //           .catch((error: any) => {
  //             setIsAuthenticated(true);
  //           });
  //       } else {
  //         setIsAuthenticated(true);
  //       }
  //       // console.log(`user = ${user}`);
  //     })
  //     .catch((error: any) => {
  //       setIsAuthenticated(true);
  //     });
  //   // console.log(`isAuthenticated1 = ${isAuthenticated}`);
  // }, [isAuthenticated]);

  // const state = useContext(LoginContext);

  const site: string | null = sessionStorage.getItem('loginUser.site') || "";
  const isAdministrator: string | null = sessionStorage.getItem('loginUser.administrator') || "";

  if (!isAuthenticated) return null;

  return (
    <React.Fragment>
      <div style={{paddingLeft: '5px', paddingRight: '5px'}}>
        <Appbar />
        <div 
          css={css({
            maxWidth: "1440px", 
            margin: '0 auto', 
            display: 'flex', 
            justifyContent: 'space-between', 
            paddingLeft: !isPhone ? '15px' : '2px', 
            paddingRight: !isPhone ? '15px' : '2px'
          })}
        >
          <SidebarLeft
            site={site}
            isAdministrator={isAdministrator}
          />
          <Route
            {...rest}
            render={
              (innerProps) => (
                ((isAuthorizedFromPeople === 'true' && peopleAccessToken && accessToken) || (isAuthorizedFromPeople !== 'true' && hasLoginUser)) 
                ? (<Route {...props} />) 
                : (
                  <Redirect
                    to={{
                      pathname: isAuthorizedFromPeople === 'true' ? redirectPeopleLogin : (!moveApproval ? '/login' : loginPath),
                      state: { from: innerProps.location },
                    }}
                  />
                )
              )
            }
          />
        </div>
        <Modal
          closeHandler={() => {
            setIsAlert(false);
          }}
          closeText=""
          open={isAlert}
          customTitle={(
            <React.Fragment>
              <div style={{
                fontSize: '24px',
                color: grayScale.gray100,
                position: 'relative',
                width: 'max-content',
                margin: 'auto',
                paddingLeft: '20px'
              }}>
                <Icon 
                  customStyle={css({
                    margin: "0 5px",
                    fontSize: '25px',
                    position: 'absolute',
                    left: '-20px',
                    bottom: '4px'
                  })} 
                  size="25px" 
                  type="warning" 
                  color={productColor.deleteAction} 
                />
                エラー・アラート警告
              </div>
            </React.Fragment>
          )}
          title=""
          submitText="閉じる"
          onSubmit={() => {
            setIsAlert(false);
          }}
        >
          <div 
            style={{
              textAlign: 'center', 
              fontSize: '14px', 
              color: 'rgb(102, 102, 102)'
            }}
          >
            エラー・アラートがあるため、締め処理が行えません。<br />
            <Link
              to="/attendError"
              style={{ color: productColor.primary, textDecoration: 'none' }}
              onClick={() => {
                setIsAlert(false);
                sessionStorage.setItem('attendError.staffCode', loginUser.staffCode)
                sessionStorage.setItem('attendError.directFromPopupAlert', 'true')
              }}>
              勤怠エラー実績
            </Link>
            で申請をしてください。
          </div>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default PrivateRoute;
